/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {FormLabel, Row} from 'react-bootstrap';
import {Conditional} from "../../Conditional";
import {HelpIcon} from "../HelpIcon";
import {useGenericModelHooks} from "../../../Hooks/GenericModelHooks";
import {useShouldEditField} from "../../../Hooks/GenericModelHooks";

import * as fieldComponents from "../../../Models/Core/FieldComponents";

export function ChildModelViewerRecordRenderer(props) {

    const {FieldDef, FieldDefinitionGroups = null, SkipBorder, Data, RootData, OnValidationUpdate, CustomData, IsNewModel} = props;

    const {
        getFieldDefs,
        updateField,
        updateFields,
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    const shouldEdit = shouldEditField(props);

    let data = FieldDef.getter(Data);
    let children = [];

    //if we're not editing and if we're dealing with an empty array we don't need to render anything. Let's just return null;
    if (!shouldEdit) {
        if (data == null || (Array.isArray(data) && (data.length === 0))) {
            children.push(
                <Row key="empty-warning" className="pop-row">
                    <div className="sb-no-items-warning">
                        <span>No {FieldDef.title}<span
                            className="sb-print-hide">{FieldDef?.association?.customData?.emptySuffix ?? " defined"}</span>.</span>
                    </div>
                </Row>
            );
        }
    }

    const EditorComponent = fieldComponents?.[FieldDef.editor] ?? null;
    const ViewerComponent = fieldComponents?.[FieldDef.viewer] ?? null;

    if(EditorComponent == null || ViewerComponent == null) {
        console.log(FieldDef);
        return null;
    }
    
    return <React.Fragment>
        <tr className={"sb-editor-row-" + FieldDef.key}>
            <Conditional Condition={FieldDef.displayLabel}>
                <td className="sb-model-viewer-column">
                    <FormLabel>
                        {FieldDef.title}
                    </FormLabel>
                    <Conditional Condition={shouldEdit && FieldDef.association?.helpText != ""}>
                        <HelpIcon id={"help-icon-" + FieldDef.key}>{FieldDef.association?.helpText}</HelpIcon>
                    </Conditional>
                </td>
            </Conditional>
            <td className="sb-model-viewer-column sb-model-viewer-column-sub-editor"
                colSpan={FieldDef.displayLabel ? 1 : 2}>
                <Conditional Condition={shouldEdit}>
                    <EditorComponent
                        Value={data}
                        OnUpdate={(y, fieldDef = FieldDef) => updateField(fieldDef, y)}
                        OnUpdates={(y) => updateFields(y)}
                        FieldDef={FieldDef}
                        RootData={RootData}
                        Data={Data}
                        FieldDefs={ FieldDefinitionGroups ?? getFieldDefs(true)}
                        OnValidationUpdate={OnValidationUpdate}
                        CustomData={CustomData}
                        IsNewModel={IsNewModel}
                    >
                        {children}
                    </EditorComponent>
                </Conditional>
                <Conditional Condition={!shouldEdit}>
                    <ViewerComponent
                        Value={data}
                        FieldDef={FieldDef}
                        RootData={RootData}
                        Data={Data}
                        FieldDefs={FieldDefinitionGroups ?? getFieldDefs(true)}
                        OnValidationUpdate={OnValidationUpdate}
                        CustomData={CustomData}
                        IsNewModel={IsNewModel}
                    >
                        {children}
                    </ViewerComponent>
                </Conditional>
            </td>
        </tr>
        <Conditional Condition={FieldDef.displayLabel && SkipBorder}>
            <tr className="separator">
                <td>
                    <hr/>
                </td>
                <td/>
            </tr>
        </Conditional>
    </React.Fragment>;
}


